import { TransitionState } from "../GameState"
import { colorNum } from "../utils/ColorUtils"
import { Scale } from "../utils/Scale"
import { Sprites } from "../utils/Sprites"
import { WorldRepo } from "../world/WorldRepo"
import { ButtonContainer, Buttons, ButtonType } from "./Buttons"
import { Rectangle } from "./Shape"

export enum DebugPanelLocation {
    UPPER_LEFT,
    LOWER_LEFT,
    LOWER_RIGHT
}

export class DebugPanel {

    private panel: Rectangle
    private returnButton: ButtonContainer
    private skipButton: ButtonContainer

    constructor(private game: Phaser.Game, private skip?: () => void, private location: DebugPanelLocation = DebugPanelLocation.UPPER_LEFT) {
        let x
        let y
        switch (location) {
            case DebugPanelLocation.LOWER_LEFT:
                x = Scale.x(0.04)
                y = Scale.y(0.82)
                break
            case DebugPanelLocation.LOWER_RIGHT:
                x = Scale.x(0.85)
                y = Scale.y(0.85)
                break
            default:
                x = Scale.x(0.04)
                y = Scale.y(0.04)
        }
        this.recreate(x, y)
    }

    setSkip = (skip: () => void, disableOnclick = true, name?: string) => {
        if (this.skipButton) {
            this.skip = skip
            this.skipButton.button.events.onInputDown.removeAll()
            this.skipButton.setOnClick(() => {
                if (disableOnclick) {
                    this.disableSkip()
                }
                skip()
            })
            this.skipButton.enable()

            if (name) {
                this.skipButton.text.text = name
                this.skipButton.text.fontSize = 14
                this.skipButton.center()
            }
        }
    }

    disableSkip = () => {
        if (this.skipButton) {
            this.skip = undefined
            this.skipButton.button.events.onInputDown.removeAll()
            this.skipButton.disable()
        }
    }

    recreate = (x?: number, y?: number) => {
        if (!WorldRepo.isDebug()) {
            return
        }
        if (this.panel && x === undefined && y === undefined) {
            x = this.panel.graphics.x
            y = this.panel.graphics.y
        }
        if (this.panel) {
            this.panel.graphics.destroy()
            this.returnButton.destroy()
            this.skipButton.destroy()
        }
        this.game.physics.startSystem(Phaser.Physics.ARCADE)
        const returnButton = Buttons.create(this.game, "Exit", () => {
            this.game.state.start(TransitionState.WORLD)
        }, {buttonType: ButtonType.GHOST})
        this.returnButton = returnButton
        const panel = new Rectangle(
            this.game,
            x !== undefined ? x : Scale.x(0.01),
            y !== undefined ? y : Scale.y(0.01),
            returnButton.button.width + Scale.x(0.02),
            returnButton.button.height * 2 + Scale.x(0.03),
            {fillColor: colorNum.secondary}
        )
        this.panel = panel
        panel.graphics.inputEnabled = true
        panel.graphics.input.enableDrag()
        this.skipButton = Buttons.create(this.game, "Skip", undefined, {buttonType: ButtonType.GHOST, enabled: this.skip !== undefined})
        if (this.skip) {
            this.setSkip(this.skip)
        }

        Sprites.evenlySpaceVertically(panel.invisibleSprite, this.skipButton.button, returnButton.button)
        this.skipButton.button.x += Scale.x(0.01)
        this.returnButton.button.x += Scale.x(0.01)
        this.skipButton.button.y -= panel.invisibleSprite.y
        this.returnButton.button.y -= panel.invisibleSprite.y

        panel.graphics.addChild(this.skipButton.button)
        panel.graphics.addChild(this.skipButton.text)
        panel.graphics.addChild(returnButton.button)
        panel.graphics.addChild(returnButton.text)

        this.skipButton.bringToTop()
        returnButton.bringToTop()
        this.skipButton.center()
        returnButton.center()
    }
}
